import i18next from "i18next";
import { z } from "zod";

export const signUpSearchSchema = z.object({
  access_token: z.optional(z.string()).catch(""),
  accessToken: z.optional(z.string()).catch(""),
});

export const signUpFormSchema = z
  .object({
    accessToken: z.string().optional(),
    defaultEmail: z.string().optional(),
    email: z.email(i18next.t("auth.signIn.invalidEmailMessage")),
    first_name: z
      .string()
      .min(1, i18next.t("auth.signUp.firstNameRequiredError")),
    last_name: z
      .string()
      .min(1, i18next.t("auth.signUp.lastNameRequiredError")),
    locale: z.string().min(1, i18next.t("auth.signUp.localeRequiredError")),
    password: z
      .string()
      .min(8, i18next.t("auth.signUp.passwordRequirementsMessage")),
    password_confirmation: z
      .string()
      .min(1, i18next.t("auth.signUp.confirmPasswordRequiredError")),
    timezone: z
      .object({
        display_name: z.string(),
        formatted_offset: z.string(),
        identifier: z.string(),
        name: z.string(),
      })
      .nullable(),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: i18next.t("auth.signUp.passwordMismatchError"),
    path: ["password_confirmation"],
  })
  .refine((data) => data.timezone !== null, {
    message: i18next.t("auth.signUp.timezoneRequiredError"),
    path: ["timezone"],
  });

export type SignUpFormValues = z.infer<typeof signUpFormSchema>;
